import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useSelector } from "react-redux";
import type { RootState } from "./store/store";

import FefoPage from "./views/fefo/pages/fefo";
import UnifiedLoginPage from "./views/auth/pages/UnifiedLoginPage";
import HomePage from "./views/home/pages/home";
import OperacoesPage from "./views/operacoes/pages/operacoes";
import SchedulingReportsPage from "./views/reports/pages/ReportsPage";
import StorePage from "./views/store/pages/store";
import FreelancerRegisterPage from "./views/freelancer/pages/freelancer-register";
import FreelancerStorePage from "./views/freelancer/pages/freelancer-stores";
import FreelancerStoreSlotsPage from "./views/freelancer/pages/freelancer-store-slots";
import FreelancerHomePage from "./views/freelancer/pages/freelancer-home";
import FreelancerScheduledStoresPage from "./views/freelancer/pages/freelancer-scheduled-stores";
import FreelancerScheduledStoreSlotsPage from "./views/freelancer/pages/freelancer-scheduled-store-slots";
import AgendaPage from "./views/agenda/pages/agenda";
import SupervisorHomePage from "./views/supervisor/pages/supervisor-home";
import AdminSistemaPage from "./views/admin-sistema/pages/AdminSistemaPage";
import UsersManagementPage from "./views/admin-sistema/pages/UsersManagementPage";
import SystemSettingsPage from "./views/admin-sistema/pages/SystemSettingsPage";
import AuditLogsPage from "./views/admin-sistema/pages/AuditLogsPage";
import AiUsagePage from "./views/admin-sistema/pages/AiUsagePage";
import SupervisorPickEvaluationFormPage from "./views/supervisor/pages/supervisor-pick-evaluation-form";
import SupervisorFreelancerEvaluationPage from "./views/supervisor/pages/supervisor-freelancer-evaluation";
import { SupervisorStoreEvaluationPage } from "./views/supervisor/pages/supervisor-store-evaluation";
import EvaluationFormsAdminPage from "./views/evaluations/pages/evaluation-forms-admin-page";
import FreelancerRatingsPage from "./views/freelancer-ratings/pages/freelancer-ratings";
import UpdatePresenceTablePage from "./views/update-presence/pages/UpdatePresenceTablePage";
import UpdatePresenceAndValuesTablePage from "./views/update-presence-table/pages/UpdatePresenceAndValuesTablePage";
import FreelancerControlPage from "./views/freelancer-control/pages/freelancer-control";
import SlotsManagerPage from "./views/scheduling/pages/SlotsManagerPage";
import { StoreEvaluationsAdminPage } from "./views/store-evaluations/pages/StoreEvaluationsAdminPage";
import { StoreEvaluationDetailPage } from "./views/store-evaluations/pages/StoreEvaluationDetailPage";
import { StoreQualityDashboardPage } from "./views/store-evaluations/pages/StoreQualityDashboardPage";
import { StoreCoveragePage } from "./views/store-evaluations/pages/StoreCoveragePage";
import Nr1PublicFormPage from "./views/nr1/pages/Nr1PublicFormPage";
import Nr1LinksAdminPage from "./views/nr1/pages/Nr1LinksAdminPage";
import Nr1DashboardPage from "./views/nr1/pages/Nr1DashboardPage";
import QuizHubPage from "./views/quiz/pages/QuizHubPage";
import QuizEditorPage from "./views/quiz/pages/QuizEditorPage";
import QuizCampaignNewPage from "./views/quiz/pages/QuizCampaignNewPage";
import QuizCampaignPage from "./views/quiz/pages/QuizCampaignPage";
import QuizPublicPage from "./views/quiz/pages/QuizPublicPage";
import CampanhasPage from "./views/campanhas/pages/CampanhasPage";
import CampanhaFormPage from "./views/campanhas/pages/CampanhaFormPage";
import CampanhaPage from "./views/campanhas/pages/CampanhaPage";
import CampanhaAssistentePage from "./views/campanhas/pages/CampanhaAssistentePage";
import CandidaturaPage from "./views/campanhas/pages/CandidaturaPage";
import PoliticaPrivacidadePage from "./views/campanhas/pages/PoliticaPrivacidadePage";
import CampanhasRoute from "./routes/CampanhasRoute";
import CriativosPage from "./views/campanhas/pages/CriativosPage";
import CriativoNovoPage from "./views/campanhas/pages/CriativoNovoPage";
import CriativoPage from "./views/campanhas/pages/CriativoPage";
import RosterSimulatorPage from "./views/simulador-escala/pages/RosterSimulatorPage";
import { SIMULADOR_ESCALA_PAGE } from "./views/simulador-escala/routes";
import DpPage from "./views/dp/pages/DpPage";
import EmployeesPage from "./views/dp/pages/EmployeesPage";
import EmployeeFormPage from "./views/dp/pages/EmployeeFormPage";
import EmployeeDetailPage from "./views/dp/pages/EmployeeDetailPage";
import DpSettingsPage from "./views/dp/pages/DpSettingsPage";
import FgtsPaymentsPage from "./views/dp/pages/FgtsPaymentsPage";
import PayrollPeriodsPage from "./views/dp/pages/PayrollPeriodsPage";
import ProvisionsPage from "./views/dp/pages/ProvisionsPage";
import PayrollPeriodPage from "./views/dp/pages/PayrollPeriodPage";
import PayrollResultPage from "./views/dp/pages/PayrollResultPage";
import InssPaymentsPage from "./views/dp/pages/InssPaymentsPage";
import ProcessesPage from "./views/dp/pages/ProcessesPage";
import ProcessDetailPage from "./views/dp/pages/ProcessDetailPage";
import ExpiringDocumentsPage from "./views/dp/pages/ExpiringDocumentsPage";
import ExpiringProbationsPage from "./views/dp/pages/ExpiringProbationsPage";
import VacationsPage from "./views/dp/pages/VacationsPage";
import LeavesPage from "./views/dp/pages/LeavesPage";
import LeaveDetailPage from "./views/dp/pages/LeaveDetailPage";
import SensitiveAccessLogsPage from "./views/dp/pages/SensitiveAccessLogsPage";
import FirstAccessPage from "./views/colaborador/pages/FirstAccessPage";
import ChangePasswordPage from "./views/colaborador/pages/ChangePasswordPage";
import EmployeeHomePage from "./views/colaborador/pages/EmployeeHomePage";
import MyVacationsPage from "./views/colaborador/pages/MyVacationsPage";
import MyLeavesPage from "./views/colaborador/pages/MyLeavesPage";
import MyPayslipsPage from "./views/colaborador/pages/MyPayslipsPage";
import MyRosterPage from "./views/colaborador/pages/MyRosterPage";
import KioskPage from "./views/quiosque/KioskPage";
import { QUIOSQUE_PAGE } from "./views/quiosque/routes";
import MyTimesheetPage from "./views/colaborador/pages/MyTimesheetPage";
import MyAdjustmentsPage from "./views/colaborador/pages/MyAdjustmentsPage";
import RostersPage from "./views/dp/pages/RostersPage";
import RosterChangeRequestsPage from "./views/dp/pages/RosterChangeRequestsPage";
import TimesheetsPage from "./views/dp/pages/TimesheetsPage";
import PresencePage from "./views/dp/pages/PresencePage";
import FlaggedPunchesPage from "./views/dp/pages/FlaggedPunchesPage";
import TimesheetDetailPage from "./views/dp/pages/TimesheetDetailPage";
import AdjustmentsQueuePage from "./views/dp/pages/AdjustmentsQueuePage";

import { FEFOPAGE } from "./views/fefo/routes";
import {
  LOGIN_UNIFICADO,
  LOGIN_CHOICE,
  LOGINPAGE,
  FREELANCER_LOGIN_PAGE,
} from "./views/auth/routes";
import { HOMEPAGE } from "./views/home/routes";
import { OPERACOES_PAGE } from "./views/operacoes/routes";
import { REPORTS_PAGE } from "./views/reports/routes";
import { STOREPAGE, STORE_DETAIL_PAGE } from "./views/store/routes";
import { StoreDetailPage } from "./views/store/pages/StoreDetailPage";
import {
  STORE_EVALUATIONS_ADMIN_PAGE,
  STORE_EVALUATION_DETAIL_PAGE,
  STORE_QUALITY_DASHBOARD_PAGE,
  STORE_COVERAGE_PAGE
} from "./views/store-evaluations/routes";
import {
  NR1_LINKS_ADMIN_PAGE,
  NR1_DASHBOARD_PAGE,
  NR1_PUBLIC_FORM_PAGE,
} from "./views/nr1/routes";
import {
  QUIZ_CAMPAIGN_NEW_PAGE,
  QUIZ_CAMPAIGN_PAGE,
  QUIZ_EDIT_PAGE,
  QUIZ_HUB_PAGE,
  QUIZ_NEW_PAGE,
  QUIZ_PUBLIC_PAGE,
} from "./views/quiz/routes";
import {
  CAMPANHAS_PAGE,
  CAMPANHA_EDIT_PAGE,
  CAMPANHA_ASSISTENTE_PAGE,
  CAMPANHA_PROXIMA_PAGE,
  CAMPANHA_NEW_PAGE,
  CAMPANHA_PAGE,
  CANDIDATURA_PAGE,
  CRIATIVOS_PAGE,
  CRIATIVO_NOVO_PAGE,
  CRIATIVO_PAGE,
  POLITICA_PRIVACIDADE_PAGE,
} from "./views/campanhas/routes";
import {
  FREELANCER_REGISTER_PAGE,
  FREELANCER_STORE_PAGE,
  FREELANCER_HOME_PAGE,
  FREELANCER_SCHEDULED_STORES_PAGE,
  FREELANCER_SCHEDULED_STORE_PAGE,
} from "./views/freelancer/routes";
import { AGENDA_PAGE } from "./views/agenda/routes";
import { ADMINPAGE } from "./views/admin/routes";
import {
  ADMIN_SISTEMA_PAGE,
  ADMIN_USUARIOS_PAGE,
  ADMIN_CONFIGURACOES_PAGE,
  ADMIN_LOGS_PAGE,
  ADMIN_CONSUMO_IA_PAGE,
} from "./views/admin-sistema/routes";
import {
  SUPERVISOR_HOME_PAGE,
  SUPERVISOR_STORE_EVALUATION_START_PAGE,
  SUPERVISOR_STORE_EVALUATION_PAGE,
} from "./views/supervisor/routes";
import { EVALUATION_FORMS_ADMIN_PAGE } from "./views/evaluations/routes";
import { FREELANCER_RATINGS_ADMIN_PAGE } from "./views/freelancer-ratings/routes";
import { UPDATE_PRESENCE_TABLE_PAGE } from "./views/update-presence/routes";
import { UPDATE_PRESENCE_AND_VALUES_TABLE_PAGE } from "./views/update-presence-table/routes";
import { FREELANCER_CONTROL } from "./views/freelancer-control/routes";
import { SLOTS_MANAGER_PAGE } from "./views/scheduling/routes";
import {
  DP_PAGE,
  DP_EMPLOYEES_PAGE,
  DP_EMPLOYEE_NEW_PAGE,
  DP_EMPLOYEE_PAGE,
  DP_EMPLOYEE_EDIT_PAGE,
  DP_SETTINGS_PAGE,
  DP_FGTS_PAGE,
  DP_PAYROLL_PAGE,
  DP_PROVISIONS_PAGE,
  DP_PAYROLL_PERIOD_PAGE,
  DP_PAYROLL_RESULT_PAGE,
  DP_INSS_PAGE,
  DP_PROCESSES_PAGE,
  DP_PROCESS_PAGE,
  DP_EXPIRING_DOCUMENTS_PAGE,
  DP_EXPIRING_PROBATIONS_PAGE,
  DP_VACATIONS_PAGE,
  DP_LEAVES_PAGE,
  DP_LEAVE_PAGE,
  DP_SENSITIVE_LOGS_PAGE,
  DP_ROSTERS_PAGE,
  DP_TIMESHEETS_PAGE,
  DP_TIMESHEET_PAGE,
  DP_ADJUSTMENTS_PAGE,
  DP_PRESENCE_PAGE,
  DP_FLAGGED_PUNCHES_PAGE,
  DP_ROSTER_CHANGES_PAGE,
} from "./views/dp/routes";
import {
  COLABORADOR_HOME,
  COLABORADOR_LOGIN,
  COLABORADOR_PRIMEIRO_ACESSO,
  COLABORADOR_SENHA,
  COLABORADOR_FERIAS,
  COLABORADOR_AFASTAMENTOS,
  COLABORADOR_ESCALA,
  COLABORADOR_ESPELHO,
  COLABORADOR_AJUSTES,
  COLABORADOR_CONTRACHEQUES,
} from "./views/colaborador/routes";

import PrivateRoute from "./routes/PrivateRoute";
import AdminRoute from "./routes/AdminRoute";
import SupervisorRoute from "./routes/SupervisorRoute";
import FreelancerRoute from "./routes/FreelancerRoute";
import LoginPublicRoute from "./routes/LoginPublicRoute";
import DpRoute from "./routes/DpRoute";
import FinanceiroRoute from "./routes/FinanceiroRoute";
import FinanceiroPage from "./views/financeiro/pages/FinanceiroPage";
import EntriesPage from "./views/financeiro/pages/EntriesPage";
import EntryFormPage from "./views/financeiro/pages/EntryFormPage";
import EntryDetailPage from "./views/financeiro/pages/EntryDetailPage";
import CashflowPage from "./views/financeiro/pages/CashflowPage";
import DrePage from "./views/financeiro/pages/DrePage";
import FinSettingsPage from "./views/financeiro/pages/FinSettingsPage";
import {
  FINANCEIRO_PAGE,
  FIN_CASHFLOW_PAGE,
  FIN_DRE_PAGE,
  FIN_ENTRY_EDIT_PAGE,
  FIN_ENTRY_NEW_PAGE,
  FIN_ENTRY_PAGE,
  FIN_PAYABLES_PAGE,
  FIN_RECEIVABLES_PAGE,
  FIN_SETTINGS_PAGE,
} from "./views/financeiro/routes";
import { useCloseModalsOnOutsideClick } from "./hooks/useCloseModalsOnOutsideClick";
import RgbRoute from "./routes/RgbRoute";
import EmployeeRoute from "./routes/EmployeeRoute";
import FreelancerOrShareRoute from "./routes/FreelancerOrShareRoute";
import StaffLayout from "./components/topbar/StaffLayout";

import { staffHomeFromToken } from "./utils/staffHome";
import { isTokenValid } from "./utils/isTokenValid";
import { PROCESSOS_ZE_PAGE } from "./views/processos-ze/routes";
import ProcessosZePage from "./views/processos-ze/pages/processos-ze";

import {
  ESTOQUE_PAGE,
  ESTOQUE_PRODUTOS_PAGE,
  ESTOQUE_BALANCO_LOJAS_PAGE,
  ESTOQUE_BALANCO_DETALHES_PAGE,
  ESTOQUE_OCORRENCIAS_PAGE,
  ESTOQUE_RELATORIOS_PAGE,
  ESTOQUE_ATUAL_PAGE,
  ESTOQUE_ENTRADAS_SAIDAS_PAGE
} from "./views/estoque/routes";
import EstoquePage from "./views/estoque/pages/EstoquePage";
import ProductReferencesPage from "./views/estoque/pages/ProductReferencesPage";
import MassBalanceStoresPage from "./views/estoque/pages/MassBalanceStoresPage";
import MassBalanceDetailsPage from "./views/estoque/pages/MassBalanceDetailsPage";
import OcorrenciasPage from "./views/estoque/pages/OcorrenciasPage";
import CurrentStockPage from "./views/estoque/pages/CurrentStockPage";
import ReportsPage from "./views/estoque/pages/ReportsPage";
import RgbHomePage from "./views/rgb/pages/RgbHomePage";
import RgbImportPage from "./views/rgb/pages/RgbImportPage";
import RgbReportPage from "./views/rgb/pages/RgbReportPage";
import RgbPackagingsPage from "./views/rgb/pages/RgbPackagingsPage";
import { RGB_HOME_PAGE, RGB_IMPORT_PAGE, RGB_PACKAGINGS_PAGE, RGB_REPORT_PAGE } from "./views/rgb/routes";

const DefaultRedirect: React.FC = () => {
  const rehydrated = useSelector((s: RootState) => !!(s as any)._persist?.rehydrated);
  const userToken = useSelector((s: RootState) => (s as any).auth?.accessToken);
  const freelancerToken = useSelector((s: RootState) => s.freelancerAuth?.accessToken);
  // Sessao do portal do colaborador. O campo e `accessToken`, o mesmo nome que o
  // slice grava — divergir dai foi o que quebrou o reconhecimento da sessao de
  // freelancer nestes mesmos redirects (BUG-006).
  const employeeToken = useSelector((s: RootState) => (s as any).employeeAuth?.accessToken);

  if (!rehydrated) return null;

  const employeeValid = isTokenValid(employeeToken);
  const freelancerValid = isTokenValid(freelancerToken);
  const userValid = isTokenValid(userToken);

  // Colaborador primeiro: e a sessao mais especifica, e quem esta no portal nao
  // tem nada a fazer na home do staff.
  if (employeeValid) return <Navigate to={COLABORADOR_HOME()} replace />;

  if (freelancerValid) return <Navigate to={FREELANCER_HOME_PAGE()} replace />;

  // Home pelo papel principal (supervisor, DP, Financeiro ou admin): `staffHomeFromToken`.
  if (userValid) return <Navigate to={staffHomeFromToken(userToken)} replace />;

  return <Navigate to={LOGIN_UNIFICADO()} replace />;
};

const App: React.FC = () => {
  // Todo modal fecha com clique fora (decisão do usuário, 03/10/2026).
  useCloseModalsOnOutsideClick();
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={2500} hideProgressBar={false} closeOnClick pauseOnHover style={{ zIndex: 999999 }} />

      <Routes>
        {/* Telas do staff: a Topbar vem do layout, uma vez só (substituiu a Sidebar de cada tela). */}
        <Route element={<StaffLayout />}>
          {/* Admin */}
          <Route
            path={HOMEPAGE()}
            element={
              <AdminRoute>
                <HomePage />
              </AdminRoute>
            }
          />
          <Route
            path={OPERACOES_PAGE()}
            element={
              <AdminRoute>
                <OperacoesPage />
              </AdminRoute>
            }
          />
          {/* Relatório de agendamentos: era o modal "Gerar relatórios" de Operações. */}
          <Route
            path={REPORTS_PAGE()}
            element={
              <AdminRoute>
                <SchedulingReportsPage />
              </AdminRoute>
            }
          />
          <Route
            path={PROCESSOS_ZE_PAGE()}
            element={
              <AdminRoute>
                <ProcessosZePage />
              </AdminRoute>
            }
          />
          <Route
            path={ADMIN_SISTEMA_PAGE()}
            element={
              <AdminRoute>
                <AdminSistemaPage />
              </AdminRoute>
            }
          />
          <Route
            path={ADMIN_USUARIOS_PAGE()}
            element={
              <AdminRoute>
                <UsersManagementPage />
              </AdminRoute>
            }
          />
          <Route
            path={ADMIN_CONFIGURACOES_PAGE()}
            element={
              <AdminRoute>
                <SystemSettingsPage />
              </AdminRoute>
            }
          />
          <Route
            path={ADMIN_LOGS_PAGE()}
            element={
              <AdminRoute>
                <AuditLogsPage />
              </AdminRoute>
            }
          />
          <Route
            path={ADMIN_CONSUMO_IA_PAGE()}
            element={
              <AdminRoute>
                <AiUsagePage />
              </AdminRoute>
            }
          />
          <Route
            path={EVALUATION_FORMS_ADMIN_PAGE()}
            element={
              <AdminRoute>
                <EvaluationFormsAdminPage />
              </AdminRoute>
            }
          />
          <Route
            path={UPDATE_PRESENCE_AND_VALUES_TABLE_PAGE()}
            element={
              <AdminRoute>
                <UpdatePresenceAndValuesTablePage />
              </AdminRoute>
            }
          />
          <Route
            path={FREELANCER_CONTROL()}
            element={
              <AdminRoute>
                <FreelancerControlPage />
              </AdminRoute>
            }
          />
          <Route
            path={SLOTS_MANAGER_PAGE()}
            element={
              <AdminRoute>
                <SlotsManagerPage />
              </AdminRoute>
            }
          />
          {/*
            As rotas `/freelancer` (sub-hub) e `/supervisor` foram removidas com a
            tela de Administração do Sistema: as duas só serviam para abrir modais
            de cadastro/edição que agora vivem em `/administracao/usuarios`.
            `/supervisor` passa a cair no alias declarado mais abaixo, que leva a
            `/supervisor-home` — comportamento desejado, ver ADR 0009.
          */}
          <Route
            path={AGENDA_PAGE()}
            element={
              <AdminRoute>
                <AgendaPage />
              </AdminRoute>
            }
          />
          {/* Usuário logado (não freelancer) */}
          <Route
            path={FEFOPAGE()}
            element={
              <PrivateRoute>
                <FefoPage />
              </PrivateRoute>
            }
          />
          <Route
            path={STOREPAGE()}
            element={
              <PrivateRoute>
                <StorePage />
              </PrivateRoute>
            }
          />
          {/* Ficha da loja: ADMIN e DP, cada aba segue o papel (plan-notificacoes-whatsapp). */}
          <Route
            path={STORE_DETAIL_PAGE()}
            element={
              <DpRoute pendingNotice={false}>
                <StoreDetailPage />
              </DpRoute>
            }
          />
          <Route
            path={ESTOQUE_PAGE()}
            element={
              <AdminRoute>
                <EstoquePage />
              </AdminRoute>
            }
          />
          <Route
            path={ESTOQUE_PRODUTOS_PAGE()}
            element={
              <PrivateRoute>
                <ProductReferencesPage />
              </PrivateRoute>
            }
          />
          <Route
            path={ESTOQUE_BALANCO_LOJAS_PAGE()}
            element={
              <PrivateRoute>
                <MassBalanceStoresPage />
              </PrivateRoute>
            }
          />
          <Route
            path={ESTOQUE_BALANCO_DETALHES_PAGE()}
            element={
              <PrivateRoute>
                <MassBalanceDetailsPage />
              </PrivateRoute>
            }
          />
          <Route
            path={ESTOQUE_OCORRENCIAS_PAGE()}
            element={
              <AdminRoute>
                <OcorrenciasPage />
              </AdminRoute>
            }
          />
          <Route
            path={ESTOQUE_ATUAL_PAGE()}
            element={
              <AdminRoute>
                <CurrentStockPage />
              </AdminRoute>
            }
          />
          <Route
            path={ESTOQUE_RELATORIOS_PAGE()}
            element={
              <AdminRoute>
                <ReportsPage />
              </AdminRoute>
            }
          />
          <Route
            path={ESTOQUE_ENTRADAS_SAIDAS_PAGE()}
            element={
              <AdminRoute>
                <ReportsPage />
              </AdminRoute>
            }
          />
          {/* Vasilhame RGB: apontamento e importação para ADMIN e supervisores; relatório e catálogo só ADMIN. */}
          <Route
            path={RGB_HOME_PAGE()}
            element={
              <RgbRoute>
                <RgbHomePage />
              </RgbRoute>
            }
          />
          <Route
            path={RGB_IMPORT_PAGE()}
            element={
              <RgbRoute>
                <RgbImportPage />
              </RgbRoute>
            }
          />
          <Route
            path={RGB_REPORT_PAGE()}
            element={
              <AdminRoute>
                <RgbReportPage />
              </AdminRoute>
            }
          />
          <Route
            path={RGB_PACKAGINGS_PAGE()}
            element={
              <AdminRoute>
                <RgbPackagingsPage />
              </AdminRoute>
            }
          />
          <Route
            path={STORE_EVALUATIONS_ADMIN_PAGE()}
            element={
              <AdminRoute>
                <StoreEvaluationsAdminPage />
              </AdminRoute>
            }
          />
          <Route
            path={STORE_EVALUATION_DETAIL_PAGE(":evaluationId")}
            element={
              <AdminRoute>
                <StoreEvaluationDetailPage />
              </AdminRoute>
            }
          />
          <Route
            path={STORE_QUALITY_DASHBOARD_PAGE()}
            element={
              <AdminRoute>
                <StoreQualityDashboardPage />
              </AdminRoute>
            }
          />
          <Route
            path={STORE_COVERAGE_PAGE()}
            element={
              <AdminRoute>
                <StoreCoveragePage />
              </AdminRoute>
            }
          />
          {/* Financeiro (ADMIN, FINANCEIRO e FINANCEIRO_LEITURA; a escrita é conferida em cada tela) */}
          <Route
            path={FINANCEIRO_PAGE()}
            element={
              <FinanceiroRoute>
                <FinanceiroPage />
              </FinanceiroRoute>
            }
          />
          <Route
            path={FIN_PAYABLES_PAGE()}
            element={
              <FinanceiroRoute>
                <EntriesPage type="PAGAR" />
              </FinanceiroRoute>
            }
          />
          <Route
            path={FIN_RECEIVABLES_PAGE()}
            element={
              <FinanceiroRoute>
                <EntriesPage type="RECEBER" />
              </FinanceiroRoute>
            }
          />
          <Route
            path={FIN_ENTRY_NEW_PAGE()}
            element={
              <FinanceiroRoute>
                <EntryFormPage />
              </FinanceiroRoute>
            }
          />
          <Route
            path={FIN_ENTRY_EDIT_PAGE()}
            element={
              <FinanceiroRoute>
                <EntryFormPage />
              </FinanceiroRoute>
            }
          />
          <Route
            path={FIN_ENTRY_PAGE()}
            element={
              <FinanceiroRoute>
                <EntryDetailPage />
              </FinanceiroRoute>
            }
          />
          <Route
            path={FIN_CASHFLOW_PAGE()}
            element={
              <FinanceiroRoute>
                <CashflowPage />
              </FinanceiroRoute>
            }
          />
          <Route
            path={FIN_DRE_PAGE()}
            element={
              <FinanceiroRoute>
                <DrePage />
              </FinanceiroRoute>
            }
          />
          <Route
            path={FIN_SETTINGS_PAGE()}
            element={
              <FinanceiroRoute>
                <FinSettingsPage />
              </FinanceiroRoute>
            }
          />
          {/* Departamento Pessoal (ADMIN e DP) */}
          <Route
            path={DP_PAGE()}
            element={
              <DpRoute>
                <DpPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_EMPLOYEES_PAGE()}
            element={
              <DpRoute>
                <EmployeesPage />
              </DpRoute>
            }
          />
          {/* Antes de :id, senao "novo" cairia na rota de detalhe como se fosse um id. */}
          <Route
            path={DP_EMPLOYEE_NEW_PAGE()}
            element={
              <DpRoute>
                <EmployeeFormPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_EMPLOYEE_EDIT_PAGE()}
            element={
              <DpRoute>
                <EmployeeFormPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_EMPLOYEE_PAGE()}
            element={
              <DpRoute>
                <EmployeeDetailPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_SETTINGS_PAGE()}
            element={
              <DpRoute>
                <DpSettingsPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_FGTS_PAGE()}
            element={
              <DpRoute>
                <FgtsPaymentsPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_PAYROLL_PAGE()}
            element={
              <DpRoute>
                <PayrollPeriodsPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_PROVISIONS_PAGE()}
            element={
              <DpRoute>
                <ProvisionsPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_PAYROLL_PERIOD_PAGE()}
            element={
              <DpRoute>
                <PayrollPeriodPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_PAYROLL_RESULT_PAGE()}
            element={
              <DpRoute>
                <PayrollResultPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_INSS_PAGE()}
            element={
              <DpRoute>
                <InssPaymentsPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_PROCESSES_PAGE()}
            element={
              <DpRoute>
                <ProcessesPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_PROCESS_PAGE()}
            element={
              <DpRoute>
                <ProcessDetailPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_EXPIRING_DOCUMENTS_PAGE()}
            element={
              <DpRoute>
                <ExpiringDocumentsPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_EXPIRING_PROBATIONS_PAGE()}
            element={
              <DpRoute>
                <ExpiringProbationsPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_VACATIONS_PAGE()}
            element={
              <DpRoute>
                <VacationsPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_LEAVES_PAGE()}
            element={
              <DpRoute>
                <LeavesPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_ROSTERS_PAGE()}
            element={
              <DpRoute>
                <RostersPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_ROSTER_CHANGES_PAGE()}
            element={
              <DpRoute>
                <RosterChangeRequestsPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_TIMESHEETS_PAGE()}
            element={
              <DpRoute>
                <TimesheetsPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_ADJUSTMENTS_PAGE()}
            element={
              <DpRoute>
                <AdjustmentsQueuePage />
              </DpRoute>
            }
          />
          <Route
            path={DP_PRESENCE_PAGE()}
            element={
              <DpRoute>
                <PresencePage />
              </DpRoute>
            }
          />
          <Route
            path={DP_FLAGGED_PUNCHES_PAGE()}
            element={
              <DpRoute>
                <FlaggedPunchesPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_TIMESHEET_PAGE()}
            element={
              <DpRoute>
                <TimesheetDetailPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_SENSITIVE_LOGS_PAGE()}
            element={
              <DpRoute>
                <SensitiveAccessLogsPage />
              </DpRoute>
            }
          />
          <Route
            path={DP_LEAVE_PAGE()}
            element={
              <DpRoute>
                <LeaveDetailPage />
              </DpRoute>
            }
          />
          {/* NR1 — pesquisa anônima */}
          <Route
            path={NR1_LINKS_ADMIN_PAGE()}
            element={
              <AdminRoute>
                <Nr1LinksAdminPage />
              </AdminRoute>
            }
          />
          <Route
            path={NR1_DASHBOARD_PAGE()}
            element={
              <AdminRoute>
                <Nr1DashboardPage />
              </AdminRoute>
            }
          />
          {/* Campanhas na Meta — ADMIN e gestor de campanhas */}
          <Route path={CAMPANHAS_PAGE()} element={<CampanhasRoute><CampanhasPage /></CampanhasRoute>} />
          <Route path={CAMPANHA_NEW_PAGE()} element={<CampanhasRoute><CampanhaFormPage /></CampanhasRoute>} />
          <Route path={CAMPANHA_ASSISTENTE_PAGE()} element={<CampanhasRoute><CampanhaAssistentePage /></CampanhasRoute>} />
          <Route path={CAMPANHA_PROXIMA_PAGE()} element={<CampanhasRoute><CampanhaAssistentePage /></CampanhasRoute>} />
          <Route path={CAMPANHA_EDIT_PAGE()} element={<CampanhasRoute><CampanhaFormPage /></CampanhasRoute>} />
          <Route path={CAMPANHA_PAGE()} element={<CampanhasRoute><CampanhaPage /></CampanhasRoute>} />
          {/* Criativos com a Eco-IA (Gemini) — ADMIN e gestor de campanhas */}
          <Route path={CRIATIVOS_PAGE()} element={<CampanhasRoute><CriativosPage /></CampanhasRoute>} />
          <Route path={CRIATIVO_NOVO_PAGE()} element={<CampanhasRoute><CriativoNovoPage /></CampanhasRoute>} />
          <Route path={CRIATIVO_PAGE()} element={<CampanhasRoute><CriativoPage /></CampanhasRoute>} />
          {/* Quiz para supervisores — cadastro, campanhas e resultados */}
          <Route
            path={QUIZ_HUB_PAGE()}
            element={
              <AdminRoute>
                <QuizHubPage />
              </AdminRoute>
            }
          />
          <Route
            path={QUIZ_NEW_PAGE()}
            element={
              <AdminRoute>
                <QuizEditorPage />
              </AdminRoute>
            }
          />
          <Route
            path={QUIZ_EDIT_PAGE()}
            element={
              <AdminRoute>
                <QuizEditorPage />
              </AdminRoute>
            }
          />
          <Route
            path={QUIZ_CAMPAIGN_NEW_PAGE()}
            element={
              <AdminRoute>
                <QuizCampaignNewPage />
              </AdminRoute>
            }
          />
          <Route
            path={QUIZ_CAMPAIGN_PAGE()}
            element={
              <AdminRoute>
                <QuizCampaignPage />
              </AdminRoute>
            }
          />
          {/* Supervisor */}
          <Route
            path={SUPERVISOR_HOME_PAGE()}
            element={
              <SupervisorRoute>
                <SupervisorHomePage />
              </SupervisorRoute>
            }
          />
          <Route
            path="/supervisor-evaluation/registration/:registrationId"
            element={
              <SupervisorRoute>
                <SupervisorPickEvaluationFormPage />
              </SupervisorRoute>
            }
          />
          <Route
            path="/supervisor-evaluation/:evaluationId"
            element={
              <SupervisorRoute>
                <SupervisorFreelancerEvaluationPage />
              </SupervisorRoute>
            }
          />
          <Route
            path={SUPERVISOR_STORE_EVALUATION_START_PAGE()}
            element={
              <SupervisorRoute>
                <SupervisorStoreEvaluationPage />
              </SupervisorRoute>
            }
          />
          <Route
            path={SUPERVISOR_STORE_EVALUATION_PAGE(":evaluationId")}
            element={
              <SupervisorRoute>
                <StoreEvaluationDetailPage />
              </SupervisorRoute>
            }
          />
          <Route
            path={UPDATE_PRESENCE_TABLE_PAGE()}
            element={
              <SupervisorRoute>
                <UpdatePresenceTablePage />
              </SupervisorRoute>
            }
          />
        </Route>

        {/*
          A tela `/admin` foi aposentada (ADR 0009): os 9 cards operacionais que
          ela duplicava ficam só em Operações, e a gestão de usuário passou para
          `/administracao`. A rota vira redirect para não quebrar link antigo.
        */}
        <Route path={ADMINPAGE()} element={<Navigate to={ADMIN_SISTEMA_PAGE()} replace />} />
        <Route
          path={FREELANCER_RATINGS_ADMIN_PAGE()}
          element={
            <AdminRoute>
              <FreelancerRatingsPage />
            </AdminRoute>
          }
        />


        {/* Quiosque da loja — o aparelho tem token próprio (ADR 0031) */}
        <Route path={QUIOSQUE_PAGE()} element={<KioskPage />} />

        {/* Portal do colaborador CLT — mundo de autenticação próprio */}
        <Route
          path={COLABORADOR_LOGIN()}
          element={<Navigate to={`${LOGIN_UNIFICADO()}?perfil=colaborador`} replace />}
        />
        <Route
          path={COLABORADOR_PRIMEIRO_ACESSO()}
          element={
            <EmployeeRoute>
              <FirstAccessPage />
            </EmployeeRoute>
          }
        />
        <Route
          path={COLABORADOR_SENHA()}
          element={
            <EmployeeRoute>
              <ChangePasswordPage />
            </EmployeeRoute>
          }
        />
        <Route
          path={COLABORADOR_HOME()}
          element={
            <EmployeeRoute>
              <EmployeeHomePage />
            </EmployeeRoute>
          }
        />
        <Route
          path={COLABORADOR_FERIAS()}
          element={
            <EmployeeRoute>
              <MyVacationsPage />
            </EmployeeRoute>
          }
        />
        <Route
          path={COLABORADOR_AFASTAMENTOS()}
          element={
            <EmployeeRoute>
              <MyLeavesPage />
            </EmployeeRoute>
          }
        />
        <Route
          path={COLABORADOR_CONTRACHEQUES()}
          element={
            <EmployeeRoute>
              <MyPayslipsPage />
            </EmployeeRoute>
          }
        />
        <Route
          path={COLABORADOR_ESCALA()}
          element={
            <EmployeeRoute>
              <MyRosterPage />
            </EmployeeRoute>
          }
        />
        <Route
          path={COLABORADOR_ESPELHO()}
          element={
            <EmployeeRoute>
              <MyTimesheetPage />
            </EmployeeRoute>
          }
        />
        <Route
          path={COLABORADOR_AJUSTES()}
          element={
            <EmployeeRoute>
              <MyAdjustmentsPage />
            </EmployeeRoute>
          }
        />

        {/* Candidatura às vagas das campanhas e a política de privacidade — sem login */}
        <Route path={CANDIDATURA_PAGE()} element={<CandidaturaPage />} />
        <Route path={POLITICA_PRIVACIDADE_PAGE()} element={<PoliticaPrivacidadePage />} />

        {/* Quiz do supervisor — sem login, entra pelo CPF */}
        <Route path={QUIZ_PUBLIC_PAGE()} element={<QuizPublicPage />} />

        {/* Simulador de escala — público, sem login; só simula, nada é gravado */}
        <Route path={SIMULADOR_ESCALA_PAGE()} element={<RosterSimulatorPage />} />

        {/* Página pública do formulário anônimo — acessível com ou sem login */}
        <Route path={NR1_PUBLIC_FORM_PAGE()} element={<Nr1PublicFormPage />} />

        {/* Freelancers */}
        <Route
          path={FREELANCER_STORE_PAGE()}
          element={
            <FreelancerRoute>
              <FreelancerStorePage />
            </FreelancerRoute>
          }
        />
        <Route
          path="/freelancer/stores/:storeId/slots/*"
          element={
            <FreelancerOrShareRoute>
              <FreelancerStoreSlotsPage />
            </FreelancerOrShareRoute>
          }
        />
        <Route
          path={FREELANCER_SCHEDULED_STORES_PAGE()}
          element={
            <FreelancerRoute>
              <FreelancerScheduledStoresPage />
            </FreelancerRoute>
          }
        />
        <Route
          path={FREELANCER_SCHEDULED_STORE_PAGE()}
          element={
            <FreelancerRoute>
              <FreelancerScheduledStoreSlotsPage />
            </FreelancerRoute>
          }
        />
        <Route
          path={FREELANCER_HOME_PAGE()}
          element={
            <FreelancerRoute>
              <FreelancerHomePage />
            </FreelancerRoute>
          }
        />

        {/* Públicas */}
        <Route
          path={FREELANCER_REGISTER_PAGE()}
          element={
            <LoginPublicRoute>
              <FreelancerRegisterPage />
            </LoginPublicRoute>
          }
        />

        {/* Tela única de login: os três perfis numa porta só (ADR 0010). */}
        <Route
          path={LOGIN_UNIFICADO()}
          element={
            <LoginPublicRoute>
              <UnifiedLoginPage />
            </LoginPublicRoute>
          }
        />

        {/* As rotas antigas continuam valendo como redirecionamento: mais de 50
            arquivos ainda navegam para elas, e o `?perfil=` faz a tela nova abrir
            já no perfil certo. */}
        <Route
          path={LOGINPAGE()}
          element={<Navigate to={`${LOGIN_UNIFICADO()}?perfil=equipe`} replace />}
        />
        <Route
          path={FREELANCER_LOGIN_PAGE()}
          element={<Navigate to={`${LOGIN_UNIFICADO()}?perfil=freelancer`} replace />}
        />
        <Route path={LOGIN_CHOICE()} element={<Navigate to={LOGIN_UNIFICADO()} replace />} />

        {/* aliases opcionais */}
        <Route path="/fefo" element={<Navigate to={FEFOPAGE()} replace />} />
        <Route path="/supervisor" element={<Navigate to={SUPERVISOR_HOME_PAGE()} replace />} />

        {/* default/fallback */}
        <Route path="/" element={<DefaultRedirect />} />
        <Route path="*" element={<DefaultRedirect />} />
      </Routes>
    </Router>
  );
};

export default App;
